/* Black Friday WISHLIST page. No libraries. */
(function () {
  'use strict';

  var PHASES = ['signup', 'early', 'sale', 'ended'];

  function clamp(v, a, b) {
    return Math.min(b, Math.max(a, v));
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  document.querySelectorAll('[data-bfw]').forEach(init);

  function init(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var early = Number(root.dataset.early) * 1000;
    var sale = Number(root.dataset.sale) * 1000;
    var end = Number(root.dataset.end) * 1000;
    var queryPhase = new URLSearchParams(window.location.search).get('bfw_phase');
    var forced = PHASES.indexOf(queryPhase) > -1 ? queryPhase : PHASES.indexOf(root.dataset.preview) > -1 ? root.dataset.preview : '';

    var phase = '';
    var countEls = {
      d: root.querySelector('[data-u="d"]'),
      h: root.querySelector('[data-u="h"]'),
      m: root.querySelector('[data-u="m"]'),
      s: root.querySelector('[data-u="s"]')
    };
    var cards = root.querySelectorAll('[data-card]');

    /* Phases and countdown */
    function computePhase(now) {
      if (forced) return forced;
      if (end && now >= end) return 'ended';
      if (sale && now >= sale) return 'sale';
      if (early && now >= early) return 'early';
      return 'signup';
    }

    function targetFor(p, now) {
      if (p === 'signup') return early || sale;
      if (p === 'early') return sale;
      if (p === 'sale') return end;
      return 0;
    }

    function setPhase(p) {
      if (p === phase) return;
      phase = p;
      root.dataset.phase = p;
      var open = p === 'sale';
      root.classList.toggle('bfw--open', open);
      cards.forEach(function (card) {
        var back = card.querySelector('[data-back]');
        if (!back) return;
        back.tabIndex = open ? 0 : -1;
        back.setAttribute('aria-hidden', open ? 'false' : 'true');
      });
    }

    function setText(el, v) {
      if (el && el.textContent !== v) el.textContent = v;
    }

    function tick() {
      var now = Date.now();
      setPhase(computePhase(now));
      var target = targetFor(phase, now);
      var diff = target ? Math.max(0, target - now) : 0;
      var secs = Math.floor(diff / 1000);
      setText(countEls.d, pad2(Math.floor(secs / 86400)));
      setText(countEls.h, pad2(Math.floor((secs % 86400) / 3600)));
      setText(countEls.m, pad2(Math.floor((secs % 3600) / 60)));
      setText(countEls.s, pad2(secs % 60));
    }

    tick();
    window.setInterval(tick, 1000);

    /* Signup forms: submit in place, replace the field with the success message */
    root.querySelectorAll('.bfw-form').forEach(function (form) {
      var err = form.querySelector('[data-bfw-error]');
      var ok = form.querySelector('[data-bfw-success]');
      if (ok && !ok.hidden) form.classList.add('is-done');

      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        if (err) err.hidden = true;
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;

        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (res) {
            if (res.url && res.url.indexOf('/challenge') > -1) {
              form.submit();
              return;
            }
            if (res.url && res.url.indexOf('customer_posted=true') > -1) {
              if (ok) ok.hidden = false;
              form.classList.add('is-done');
            } else if (err) {
              err.hidden = false;
            }
          })
          .catch(function () {
            if (err) err.hidden = false;
          })
          .then(function () {
            if (btn) btn.disabled = false;
          });
      });
    });

    /* Travelling hairline: start when a frame enters view */
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(onIntersect, { threshold: 0.35 }) : null;

    function onIntersect(entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }

    root.querySelectorAll('[data-trace], [data-trace-text]').forEach(function (el) {
      if (io && !reduce) io.observe(el);
    });

    /* Statement: each word brightens smoothly as the block scrolls up the screen */
    var stmt = root.querySelector('[data-bfw-statement]');
    var stack = stmt ? stmt.querySelector('.bfw-statement__stack') : null;
    var words = stmt ? Array.prototype.slice.call(stmt.querySelectorAll('[data-word]')) : [];
    var shown = 0;
    var aim = 0;
    var running = false;

    function aimFor() {
      var vh = window.innerHeight;
      var top = stack.getBoundingClientRect().top;
      return clamp((vh * 0.92 - top) / (vh * 0.5), 0, 1);
    }

    function paintWords(p) {
      var n = words.length;
      var spread = 2.4;
      for (var i = 0; i < n; i++) {
        var k = clamp((p * (n - 1 + spread) - i) / spread, 0, 1);
        k = k * k * (3 - 2 * k);
        words[i].style.setProperty('--w', k.toFixed(3));
      }
    }

    function glide() {
      shown += (aim - shown) * 0.09;
      if (Math.abs(aim - shown) < 0.0008) shown = aim;
      paintWords(shown);
      if (shown !== aim) {
        window.requestAnimationFrame(glide);
      } else {
        running = false;
      }
    }

    function nudge() {
      aim = aimFor();
      if (running) return;
      running = true;
      window.requestAnimationFrame(glide);
    }

    if (words.length && stack) {
      if (reduce) {
        paintWords(1);
      } else {
        window.addEventListener('scroll', nudge, { passive: true });
        window.addEventListener('resize', nudge);
        aim = aimFor();
        shown = aim;
        paintWords(shown);
      }
    }

    /* Big number: count up from zero on entering view */
    var num = root.querySelector('[data-bfw-num]');
    var fig = num ? num.querySelector('[data-fig]') : null;
    if (fig) {
      var target = Number(fig.dataset.target) || 0;
      var digits = String(target).length < 2 ? 2 : String(target).length;
      var paint = function (v) {
        var s = String(Math.round(v));
        while (s.length < digits) s = '0' + s;
        setText(fig, s + '%');
      };

      if (reduce || !io) {
        paint(target);
        num.classList.add('is-in');
      } else {
        paint(0);
        var started = false;
        var numIo = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting || started) return;
            started = true;
            numIo.disconnect();
            num.classList.add('is-in');
            var t0 = performance.now();
            var dur = 1600;
            (function step(t) {
              var k = clamp((t - t0) / dur, 0, 1);
              var eased = 1 - Math.pow(1 - k, 3);
              paint(target * eased);
              if (k < 1) window.requestAnimationFrame(step);
            })(t0);
          },
          { threshold: 0.5 }
        );
        numIo.observe(num);
      }
    }

    /* Gallery videos play only while on screen */
    var videos = root.querySelectorAll('.bfw-video');
    if (videos.length && 'IntersectionObserver' in window && !reduce) {
      var vio = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              v.pause();
            }
          });
        },
        { threshold: 0.3 }
      );
      videos.forEach(function (v) {
        v.muted = true;
        v.loop = true;
        v.setAttribute('playsinline', '');
        vio.observe(v);
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) videos.forEach(function (v) { v.pause(); });
      });
    }
  }
})();
